module.exports = "/_next/static/images/NA-e69384c87c0680db055586c148d54ccd.png";